import { RefreshCw } from "lucide-react";
import { formatLastUpdated } from "@/hooks/useRefreshCycle";

interface Props {
  lastUpdatedAt: number;
  onRefresh: () => void;
}

export function LastUpdatedIndicator({ lastUpdatedAt, onRefresh }: Props) {
  return (
    <div
      data-testid="last-updated-indicator"
      className="flex items-center justify-between px-1"
    >
      <span
        data-testid="last-updated-text"
        data-updated-at={lastUpdatedAt}
        className="text-[10px] text-muted-foreground"
      >
        {formatLastUpdated(lastUpdatedAt)}
      </span>
      <button
        type="button"
        data-testid="manual-refresh-button"
        onClick={onRefresh}
        aria-label="Refresh"
        className="inline-flex items-center gap-1 text-[10px] text-muted-foreground hover:text-foreground min-h-[44px] min-w-[44px] justify-center -mr-2"
      >
        <RefreshCw className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
